import { createApi } from '@reduxjs/toolkit/query/react';

import { X_COM_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

const TagTypes = {
    E_REFERRAL_STATUS: 'E_REFERRAL_STATUS',
};

export const xComApi = createApi({
    baseQuery: getBaseQuery(X_COM_API_URL),
    tagTypes: [TagTypes.E_REFERRAL_STATUS],
    reducerPath: 'xComApi',
    endpoints: (build) => ({
        postSendEReferral: build.mutation({
            query: ({ payerId, treatmentId, referralId, reason, source }) => ({
                url: `pharmacy-servicing/retry`,
                method: 'POST',
                body: {
                    payer_id: payerId,
                    treatment_id: treatmentId,
                    referral_id: referralId,
                    reason,
                    source: source ?? null,
                },
            }),
            invalidatesTags: (_results, _error, { referralId }) => [
                { type: TagTypes.E_REFERRAL_STATUS, id: referralId },
            ],
        }),
        getEReferralStatus: build.query({
            query: ({ referralId }) => ({
                url: `pharmacy-servicing/${referralId}/status`,
                method: 'GET',
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving e-referral delivery status.', err);
                }
            },
            providesTags: (_results, _error, { referralId }) => [
                { type: TagTypes.E_REFERRAL_STATUS, id: referralId },
            ],
        }),
    }),
});

export const { usePostSendEReferralMutation, useGetEReferralStatusQuery } = xComApi;
